import { debounce } from 'lodash';
import constants from '../constants/constants';
import services from '../services/services';

const isEmail = value => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

const validateForm = async (request, delivery) => {
  const { productList, address, email, phone, invoice, invName, company, tax, invAddress } = request;

  const response = {};
  // console.log('validate form 1', new Date().toISOString());

  // Házhozszállításnál ki kell tölteni a cím adatokat
  if (delivery) {
    for (const key in address) {
      if (address[key] === '' || address[key] === null) {
        response[key] = 'error';
      }
    }

    if (phone.length < 11 || !/^\d+$/.test(phone.slice(1, phone.length))) {
      response.phone = 'Érvényes telefonszámot adjon meg';
    }
  }
  // console.log('validate form 2', new Date().toISOString());

  if (!isEmail(email)) response.email = 'Kérjük érvényes email címet adjon meg';
  // console.log('validate form 3', new Date().toISOString());

  if (!productList || !Object.keys(productList).length) response.productList = 'Nem választott terméket!';
  // console.log('validate form 4', new Date().toISOString());

  // Számlázásnál ki kell tölteni az adatokat
  if (invoice) {
    // Számlázási név
    if (invName === '' || invName === null) {
      response.invName = 'Adjon meg számlázási nevet';
    }
    // console.log('validate form 5', new Date().toISOString());
    // Számlázási cím
    for (const key in invAddress) {
      // console.log(`address: ${invAddress[key]}`);
      if (invAddress[key] === '' || invAddress[key] === null) {
        response[key] = 'error';
      }
    }
    // console.log('validate form 6', new Date().toISOString());
    // Cég esetén adószám
    if (company) {
      // Ki van-e töltve?
      if (tax === '' || tax === null) response.tax = 'Adjon meg adószámot';
      // 2020-09-30 pjung TODO Csak ha van parMAN kapcsolat...
      else {
        let parman = await services.getSetting('parman');
        console.log('parman', parman);
        if (typeof parman.data !== 'undefined') parman = parman.data;
        if (parman) {
          const check = await check1Tax(tax);
          // console.log('validate form 6.5', new Date().toISOString());
          console.log('check', check);
          // Egy "speciális" érték lehet: FALSE, minden más szöveges hibaüzenet...
          if (check) response.tax = check;
        } else {
          // DONE Offline ellenőrzés
          const check = utils.checkTax(tax);
          console.log(check);
          if (check) response.tax = 'Érvényes adószámot adjon meg';
        }
      }
    }
    // console.log('validate form 7', new Date().toISOString());
    // console.log(response);
  }
  return response;
};

const getDaysToChooseFrom = (daysInAdvance, daysToDisable, orderUntil, todayOrderUntil, nextOrder = 0) => {
  let nextOrderTemp = nextOrder;
  const nextDay = new Date();
  nextDay.setDate(nextDay.getDate() + nextOrderTemp);
  const dateArray = [];

  const noDisabledDays = !daysToDisable || !daysToDisable?.length;

  if (nextOrderTemp === 0) {
    const today = new Date();
    // 2021-04-06 pjung ERINT-951 Mai nap engedélyezése...
    const todayNotDisabled = noDisabledDays || !daysToDisable.includes(today.getDay());
    console.debug('today:', today.getHours(), todayOrderUntil, todayNotDisabled);
    if (today.getHours() < todayOrderUntil && todayNotDisabled) {
      // eslint-disable-next-line
      const dayName = constants.days.filter(dayObj => dayObj.id == today.getDay())[0]?.name;
      dateArray.push(`${today.toISOString().slice(0, 10)} (${dayName})`);
    }
    nextOrderTemp = 1;
    nextDay.setDate(today.getDate() + nextOrderTemp);
  }

  if (nextDay.getHours() < orderUntil && (noDisabledDays || !daysToDisable.includes(nextDay.getDay()))) {
    // eslint-disable-next-line
    const dayName = constants.days.filter(dayObj => dayObj.id == nextDay.getDay())[0]?.name;
    dateArray.push(`${nextDay.toISOString().slice(0, 10)} (${dayName})`);
  }

  for (let i = nextOrderTemp + 1; i <= nextOrderTemp + daysInAdvance; i++) {
    const current = new Date();
    current.setDate(current.getDate() + i);

    const dayId = current.getDay();

    if (noDisabledDays || !daysToDisable.includes(current.getDay())) {
      // eslint-disable-next-line
      const dayName = constants.days.filter(dayObj => dayObj.id == dayId)[0]?.name;
      dateArray.push(`${current.toISOString().slice(0, 10)} (${dayName})`);
    }
  }
  return dateArray.slice(0, daysInAdvance);
};

const priceMask = num => {
  let response;
  if (num) {
    response = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  if (num === 0) {
    response = num;
  }

  return response;
};

const check1Tax = async tax => {
  // console.log('validate tax 1', new Date().toISOString());
  const res = checkTax(tax);
  // console.log('validate tax 2', new Date().toISOString());
  if (res) {
    // console.log(res);
    return 'Érvényes adószámot adjon meg';
  }
  // console.log('validate tax 3', new Date().toISOString());
  const check = await services.checkTax(tax);
  // console.log('validate tax 4', new Date().toISOString());
  // console.log(check);
  if (check?.data?.status !== 'OK') {
    // console.log(check?.data?.status);
    return false;
  }
  if (check?.data?.data?.startsWith('NAVOnline.Error')) {
    // console.log(check.data.data);
    return 'Érvényes adószámot adjon meg';
  }
  return false;
};

/** **********************************************
 * Adószám ellenőrzése
 * - Rossz a kapott érték hossza (csak 13 karakter lehet)
 * - A kapott érték nem a 99999999-9-99 formában van
 * - A 9. számjegy nem 1, 2 vagy 3 szerepel (adómentes, adóköteles, EVA)
 *   (Lehet 4 és 5 is...)
 * - Az utolsó két számjegy nem a következők egyike: 02-20, 22-44, 51
 * - CDV hibás
 *********************************************** */
const checkTax = a => {
  if (a === '' || a === null || a.length !== 13) return 'Érvénytelen hossz';
  if (a.charAt(8) !== '-' || a.charAt(10) !== '-')
    return 'Érvénytelen formátum';
  const aa = a.substring(0, 8) + a.substring(9, 10) + a.substring(11);
  Number.parseInt(aa, 10);
  let c = a.charAt(8);
  if (c < '1' || c > '5') return 'Érvénytelen típus';
  let i = Number.parseInt(aa.substring(9, 11), 10);
  if (i < 2 || i === 21 || (i > 44 && i !== 51)) return 'Érvénytelen típus';

  const tomb = [];
  for (i = 0; i < 7; i++) {
    tomb[i] = Number.parseInt(a.charAt(i), 10);
  }
  c = calcCDV(tomb, sulyAdo);
  if (a.charAt(7) !== c) return `Adószám CDV hibás, a helyes: ${c}`;
  return false;
};

const sulyAdo = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7, 3, 1, 9, 7, 3];

const calcCDV = (tomb, suly) => {
  let cdv = 0;
  let i;
  for (i = 0; i < tomb.length; i++) {
    cdv += tomb[i] * suly[i];
    // console.log(tomb[i] + ', ' + suly[i] + ', ' + cdv);
  }
  return `${(10 - (cdv % 10)) % 10}`;
};

const isTodayDisabled = disabledDays => {
  return disabledDays?.includes(new Date().getDay());
};

const todayData = () => {
  const today = new Date();
  // eslint-disable-next-line
  const dayName = constants.days.filter(dayObj => dayObj.id == today.getDay())[0]?.name;
  return `${today.toISOString().slice(0, 10)} (${dayName})`;
};

const utils = {
  validateForm,
  getDaysToChooseFrom,
  priceMask,
  debounce,
  checkTax,
  isTodayDisabled,
  todayData
};

export default utils;
